/** Marble Roulette 캔버스·물리 타이밍 (lazygyu/roulette data/constants.ts 기준) */
import type { ColorTheme } from './types/ColorTheme';

export const canvasWidth = 1600;
export const canvasHeight = 900;

export const STUCK_DELAY = 5000;

export const themeMarbleDark: ColorTheme = {
  background: '#0d0d0d',
  marbleLightness: 75,
  marbleWinningBorder: '#ffffff',
  winnerBackground: 'rgba(0, 0, 0, 0.5)',
  winnerOutline: '#000000',
  winnerText: '#ffffff',
  entity: {
    box: {
      fill: '#00bcd4',
      outline: '#00bcd4',
      bloom: '#00ffff',
      bloomRadius: 15,
    },
    circle: {
      fill: '#ffeb3b',
      outline: '#ffeb3b',
      bloom: '#ffff00',
      bloomRadius: 15,
    },
    polyline: {
      fill: '#ffffff',
      outline: '#ffffff',
      bloom: '#00ffff',
      bloomRadius: 15,
    },
  },
};
